import { ID } from '@datorama/akita';

import { Entity, Column } from '../entity';
import { ColumnType, LanguagePage, PageTitles } from '../interfaces/types';
import { IEntity } from '../interfaces/models';

export interface IValue extends IEntity {
  picklistId: string;
  value: string;
  position: number;
  visible: boolean;
  displayValue: { [key: string]: string };
}

@Entity({
  name: PageTitles.value,
  language: LanguagePage.value,
})
export class Value implements IValue {
  @Column({
    type: ColumnType.string,
    isEditable: true,
    table: {
      defaultPosition: 1,
    },
    form: {
      defaultPosition: 1,
    },
  })
  value: string;

  @Column({
    type: ColumnType.boolean,
    table: {
      defaultPosition: 2,
    },
    form: {
      defaultPosition: 2,
    },
  })
  visible: boolean;

  @Column({
    type: ColumnType.number,
    isEditable: true,
    table: {
      defaultPosition: 4,
    },
    form: {
      defaultPosition: 4,
    },
  })
  position: number;

  @Column({
    type: ColumnType.string,
    isEditable: true,
    table: {
      defaultPosition: 3,
    },
    form: {
      defaultPosition: 3,
      hide: true,
    },
  })
  displayValueString: string;

  id: ID;
  picklistId: string;
  displayValue: { [key: string]: string };
  createdAt?: Date;
  modifiedAt?: Date;
  createdBy?: string;
  modifiedBy?: string;
  href?: string;

  constructor(
    val: IValue = {
      id: '',
      picklistId: '',
      value: '',
      position: 0,
      displayValue: {},
      visible: false,
    }
  ) {
    const { id, picklistId, value, position, visible, displayValue } = val;

    this.id = id;
    this.picklistId = picklistId;
    this.value = value;
    this.position = position;
    this.visible = visible;
    this.displayValue = displayValue;
  }

  static createFromDTO(record: IValue): Value {
    return new Value({
      ...record,
      modifiedAt: record.modifiedAt ? new Date(record.modifiedAt) : null,
      createdAt: record.createdAt ? new Date(record.createdAt) : null,
    });
  }
}
